import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { environment as env } from '../../../../../environments/environment';

@Component({
    selector: 'app-action-note',
    templateUrl: './action-note.component.html',
    styleUrls: ['./action-note.component.scss'],
})
export class ActionNoteComponent implements OnInit {
    @Input() note: any;

    viewImage$ = new Subject<string>();

    constructor() {}

    ngOnInit(): void {}

    getFilePath(file) {
        return `${env.imageUploadPath}notes/file/${file}`;
    }

    viewFile(file) {
        this.viewImage$.next(this.getFilePath(file));
    }
}
